<template>
  <b-container fluid>

    <ReanalyzeView
      v-if="data"
      :data="data"
    />
  </b-container>
</template>

<script>
import { BContainer } from 'bootstrap-vue';
import ReanalyzeView from '../ViewBalance/components/Reanalyze/Reanalyze.vue';

import BalanceService from '@/service/balance/';

export default {
    components: {
        BContainer,
        ReanalyzeView,
    },

    data() {
        return {
            data: null,
        };
    },

    mounted() {
        this.getData();
    },

    methods: {
        async getData() {
            const { id } = this.$route.params;
            const { data } = await BalanceService.viewBalances(id);
            this.data = data;
        },
    },
};
</script>
